import React from 'react';
import {
  ChatsWhatsappThAtualizado,
  ChatsWhatsappThContato,
  ChatsWhatsappThCorretor,
  ChatsWhatsappThMsgs,
  ChatsWhatsappThSolicitacao,
  ChatsWhatsappThStatus,
  ChatsWhatsappThTelefone,
  ChatsWhatsappThUltimaMsg,
} from './chatsWhatsappTable.styles';

const ChatsWhatsappTableHeader = ({ chatTipo = 'coleta', showTelefoneColumn = true }) => {
  if (chatTipo === 'solicita') {
    return (
      <tr>
        <ChatsWhatsappThSolicitacao>ID</ChatsWhatsappThSolicitacao>
        <ChatsWhatsappThCorretor>USUÁRIO</ChatsWhatsappThCorretor>
        <ChatsWhatsappThUltimaMsg>CÓD.IMÓVEL/ENDEREÇO</ChatsWhatsappThUltimaMsg>
        <ChatsWhatsappThContato>PRETENDENTES</ChatsWhatsappThContato>
        <ChatsWhatsappThMsgs>MSGS</ChatsWhatsappThMsgs>
        <ChatsWhatsappThAtualizado>ÚLT.MSG</ChatsWhatsappThAtualizado>
        <ChatsWhatsappThStatus>STATUS</ChatsWhatsappThStatus>
      </tr>
    );
  }

  return (
    <tr>
      <ChatsWhatsappThContato>Pretendente</ChatsWhatsappThContato>
      {showTelefoneColumn && <ChatsWhatsappThTelefone>Telefone</ChatsWhatsappThTelefone>}
      <ChatsWhatsappThCorretor>Usuário/Imobiliária</ChatsWhatsappThCorretor>
      <ChatsWhatsappThSolicitacao>Solicitação</ChatsWhatsappThSolicitacao>
      <ChatsWhatsappThUltimaMsg>Última mensagem</ChatsWhatsappThUltimaMsg>
      <ChatsWhatsappThMsgs>Msgs</ChatsWhatsappThMsgs>
      <ChatsWhatsappThAtualizado>Atualizado</ChatsWhatsappThAtualizado>
      <ChatsWhatsappThStatus>Status</ChatsWhatsappThStatus>
    </tr>
  );
};

export default ChatsWhatsappTableHeader;
